module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAWCAMAAAAo0TYrAAAAllBMVEUAAAAAgP8Aqv8A//8Av/9Av/8zzMwzzP8r1dUr1f8kttsk2/8gv/8rv+opzPU1y/AzzPAvyfIuy/IzzPIyx/MyzfMxyO0xyPMxzvMvyvMuy/M0y/MzzPQyyPQxye8xyfQwyvQzyPIyyfIzyPAxy/Exy/M0y/MyyvAyyvMyyvAyyvM0y/QzyfEzyfQyx/EzzPIyyvI0yfKOFilTAAAAMnRSTlMAAgMDBAQFBQYGBwcIDBkiIyYnKCkpKioqKywsLS4vLzA8PUZJU1NWVldXWVpaW19hY6V2d98AAACISURBVBjTzY5JAoIwEAQbEsWETRaVAELcIRkV//85D6jwBPvUdaoCAMDd3fYM01hJejFnZZo/ZUeyHzPpIDoo8WGhjhGKnnLuFqZhPKe+QJBamyyzrlol1qYBwLd3E2fXct09NhwAvIq6kzkbqrxRIWoangPV4quXLb2olVOPry/an/UhVOF43k6RDsLkSkaDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home3_down.png
// module id = CJi0
// module chunks = 0